var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSouthAfrica2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "south_africa@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-493.000000, -621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "south_africa"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_7_copy-43",
    fill: "#4758A9",
    x: 0.39,
    y: 0.55,
    width: 70,
    height: 47,
    rx: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,0.55 L6.75,0.55 C3.23746899,0.55 0.39,3.39746899 0.39,6.91 L0.39,20.55 L70.39,20.55 L70.39,6.91 C70.3900188,5.2180124 69.7158327,3.59575845 68.5166051,2.40216095 C67.3173774,1.20856345 65.6919688,0.542018926 64,0.55 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29,16 L8.79,0.5 L6.79,0.5 C3.27746899,0.5 0.43,3.34746899 0.43,6.86 L0.43,41.13 C0.43,44.642531 3.27746899,47.49 6.79,47.49 L8.79,47.49 L36.29,31.99 L70.38,31.99 L70.38,16 L36.29,16 Z M35,27 L4.44,44.22 C3.46805013,43.4949976 2.89683196,42.3525613 2.9,41.14 L2.9,6.91 C2.89683196,5.69743869 3.46805013,4.55500235 4.44,3.83 L35,21 L67.91,21 L67.91,27 L35,27 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46,1 C2.0046682,1.94288163 0.383008004,4.29985344 0.38,6.93 L0.38,41.2 C0.383008004,43.8301466 2.0046682,46.1871184 4.46,47.13 L35.63,29.56 L70.38,29.56 L70.38,18.56 L35.64,18.56 L4.46,1 Z",
    id: "Shape",
    fill: "#57A863"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCE54",
    points: "0.39 7.47 0.39 10.49 24.41 24.05 0.39 37.61 0.39 40.63 29.41 24.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#434A54",
    points: "24.41 24.05 0.39 10.49 0.39 24.05 0.39 37.61"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica2X);
export default __webpack_public_path__ + "static/media/south_africa@2x.29cc0c023d9f953d673c62ba84e7fd83.svg";
export { ForwardRef as ReactComponent };